module.exports = __webpack_public_path__ + "img/65.5.COD.a35e43e7.png";